//const API_BASE_URL = 'http://localhost:5000/api/';
//const FE_BASE_URL = 'http://localhost:3000/';

//const IMAGE_PATH_COMPELETE = 'http://localhost:5000/api/';

const API_BASE_URL = 'https://event-booking-backend-gamma.vercel.app/api/';
const FE_BASE_URL = 'https://hotels-broker.netlify.app/';

const IMAGE_PATH_COMPELETE = 'https://event-booking-backend-gamma.vercel.app/'
const IMAGE_PATH = 'https://onecinex.com'

// const API_BASE_URL = '/api/';
// const FE_BASE_URL = '/';
// const IMAGE_PATH_COMPELETE = 'https://onecinex.com/';

const COUNTRIES_API_KEY = 'QUtQMnJqQVNodVNhZlZpT2RDTXZCRFI5SXJwQ29yM29JTlZTVjZPVg==';

export { API_BASE_URL, FE_BASE_URL,  IMAGE_PATH_COMPELETE, COUNTRIES_API_KEY, IMAGE_PATH };